import axios from 'axios';

// Get the environment from .env file, fallback to 'development' if not set
const ENV = process.env.VUE_APP_ENV || 'development';

// API URL configuration based on environment
const API_URLS = {
  development: 'http://10.200.200.1/v2/',
  local: 'http://localhost:8000/',
  production: 'https://app.dentmenu.com/v2/'
};

// JavaScript backend URL
const JS_BACKEND_URL = 'https://onboarding-backend-d7kg.vercel.app/plan';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_URLS[ENV],
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// API endpoints
export const endpoints = {
  plan: {
    add: 'add-plan/',
    get: (key) => `plan?key=${key}`,
    update: 'plan',
    submit: (key) => `submit?key=${key}`,
    checkLandingPage: 'check-landing-page-url',
    createLandingPage: (key) => `create_landing_page?key=${key}`
  },
  company: {
    details: 'company-details'
  }
};

// API functions
export const apiService = {
  // Plan related functions
  async getPlan(planKey) {
    try {
      const response = await api.get(endpoints.plan.get(planKey));
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return 404;
      if (error.response?.status === 500) return 500;
      throw error;
    }
  },

  async addPlan(planData, isIntake = false) {
    const json = {
      practiceName: planData.practiceName,
      plans: JSON.stringify(planData),
      isIntake
    };
    
    try {
      const response = await api.post(endpoints.plan.add, json);
      return response.data.key;
    } catch (error) {
      if (error.response?.status === 500) return 500;
      throw error;
    }
  },

  async updatePlan(planId, planData, changelog) {
    const json = {
      id: planId,
      plans: JSON.stringify(planData),
      changes: changelog
    };

    try {
      const response = await api.put(endpoints.plan.update, json);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return 404;
      if (error.response?.status === 500) return 500;
      throw error;
    }
  },

  async submitPlan(planKey, extraData) {
      const response = await api.post(endpoints.plan.submit(planKey), extraData);
      return response;

  },

  async createLandingPage(planKey, extraData) {
      const response = await api.post(endpoints.plan.createLandingPage(planKey), extraData);
      return response;

  },

  async checkLandingPageUrl(landingPage) {
    try {
      const response = await api.get(endpoints.plan.checkLandingPage, {
        params: { landingPage }
      });
      return { isAvailable: !response.data.result, error: null };
    } catch (error) {
      return { isAvailable: false, error };
    }
  },

  async getCompanyDetails(companyId, options = {}) {
    try {
      const config = {
        method: options.method || 'GET',
      };
      
      if (options.method === 'POST') {
        config.url = endpoints.company.details;
        config.headers = {
          'Content-Type': 'application/json'
        };
        // For POST, only send the data without companyID
        config.data = options.data;
      } else {
        // For GET requests, append the query parameter
        config.url = `${endpoints.company.details}?companyID=${companyId}`;
      }
      
      const response = await api(config);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return 404;
      if (error.response?.status === 500) return 500;
      throw error;
    }
  }
};

export default api; 